module.exports = "//static.hsappstatic.net/pricing-pages-ui/static-1.19801/js/img/splash-page/top-left-yolk.svg"